<div>
  <app-heading-small-component
    heading1="Elevate Your Teaching with "
    heading2=" Innovative Tools"
    heading3=""
    description="Engage students, simplify tasks, and focus on what you do best—teaching."
    imageUrl="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-1.png"
  ></app-heading-small-component>
  <app-cards-wrap
    class="cards-wrap"
    heading1="How we"
    heading2="make it easy"
    heading3="for teachers"
    heading4="?"
    subheading="See how you can benefit →"
    [array]="benifits"
  ></app-cards-wrap>

  <app-features-card class="features-card"></app-features-card>
</div>
